import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './LanguageSwitcher.module.css';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLang);
    localStorage.setItem('preferredLanguage', newLang);
  };

  return (
    <button 
      onClick={toggleLanguage}
      className={styles.languageSwitcher}
      aria-label="Switch language"
      title={i18n.language === 'fr' ? 'Switch to English' : 'Passer au français'}
    >
      {i18n.language === 'fr' ? (
        <>
          <span className={styles.flag}>🇬🇧</span>
          <span className={styles.langCode}>EN</span>
        </>
      ) : (
        <>
          <span className={styles.flag}>🇫🇷</span>
          <span className={styles.langCode}>FR</span>
        </>
      )}
    </button>
  );
};

export default LanguageSwitcher;
